import contentfulGql from 'js/lib/contentfulGql';

export const BrowseFAQQuery = contentfulGql`#graphql
  query BrowseFAQQuery(
    $preview: Boolean!
    $contentfulPageId: String!
    $pageTypeSlug: String!
    $locale: String!
    $domainSlug: String
  ) {
    browseEntityPageCollection(
      preview: $preview
      locale: $locale
      where: { slug: $contentfulPageId, pageTypeSlug: $pageTypeSlug, domainSlug: $domainSlug }
    ) {
      items {
        domainSlug
        subdomainSlug
        slug
        faqsCollection {
          items {
            sectionName
            question
            answer
          }
        }
      }
    }
  }
`;
